import { AppManager, assetDir } from '@common';
import * as PANOLENS from 'panolens';
import * as THREE from 'three';
import { textSprite, textSpriteTexture, textSpriteUpdateScale } from '../utils/textSprite';
import BaseInteractiveSpot from './BaseInteractiveSpot';

const labelScale = 0.2;
const labelStyle = {
  fontSize: 48,
  fontFamily: 'font-en',
  fillStyle: 'rgba(255, 255, 255, 1.0)',
  trimCanvas: false,
};
const spriteYFactor = 0.7;

export default class InfoLinkSpot extends BaseInteractiveSpot {
  constructor(panoCtl, panoCtlTo, linkConfig) {
    super(panoCtl.panorama);
    this.panoCtl = panoCtl;
    this.panoCtlTo = panoCtlTo;
    this.linkConfig = linkConfig;

    const labelImage = this.panoCtlTo.linkLabelImage;
    if (labelImage) {
      new THREE.TextureLoader().load(labelImage, (tex) => {
        this.labelImageMesh = this.createLabelImageButton(tex);
      });
    } else {
      new THREE.TextureLoader().load(
        `${assetDir}/images/buttons/transfer_s.png`,
        (tex) => {
          this.buttonMesh = this.createButton(tex);
          this.labelMesh = this.createLabel();
        }
      );
    }
    this.panorama.addEventListener('change-language', this.onChangeLanguage.bind(this));
  }


  createButton(baseTex) {
    baseTex.needsUpdate = true;
    const info = new PANOLENS.Infospot(800, baseTex, false, {
      yScaleFactor: spriteYFactor,
      textureAngle: (this.linkConfig.rotate !== undefined) ?
        THREE.Math.degToRad(parseInt(this.linkConfig.rotate) - 90) : 0,
      onHoverStart: this.onHoverStart,
      onHoverEnd: this.onHoverEnd,
      onTouchStart: this.onTouchStart,
    });
    info.position.fromArray(this.linkConfig.positionAt);
    info.addEventListener('click', this.onLinkClick.bind(this));
    info.name = `linkto-${this.panoCtlTo.panoramaId}`;
    this.panorama.add(info);
    return info;
  }


  createLabelImageButton(baseTex) {
    baseTex.needsUpdate = true;
    const info = new PANOLENS.Infospot(1500, baseTex, false, {
      textureAngle: (this.linkConfig.rotate !== undefined) ?
        THREE.Math.degToRad(parseInt(this.linkConfig.rotate) - 90) : 0,
      onHoverStart: this.onHoverStart,
      onHoverEnd: this.onHoverEnd,
      onTouchStart: this.onTouchStart,
    });
    info.position.fromArray(this.linkConfig.positionAt);
    info.addEventListener('click', this.onLinkClick.bind(this));
    info.name = `linkto-${this.panoCtlTo.panoramaId}`;
    this.panorama.add(info);
    return info;
  }


  createLabel() {
    if (!this.panoCtlTo.linkLabel) return null;
    const labelSprite = textSprite(this.label, labelScale, labelStyle);
    labelSprite.name = `linklabel-${this.label}`;
    labelSprite.material.sizeAttenuation = false;
    labelSprite.scale.multiplyScalar(0.0004);
    this.buttonMesh.addLabel(labelSprite, {
      offsetY: 0.75
    });
    return labelSprite;
  }


  onLinkClick(event) {
    AppManager.gotoPanorama(this.panoCtlTo);
  }


  onChangeLanguage() {
    if (this.labelImageMesh && this.labelImageMesh.material) {
      new THREE.TextureLoader().load(this.panoCtlTo.linkLabelImage, tex => {
        this.labelImageMesh.material.map = tex;
      });
    }
    if (this.labelMesh && this.labelMesh.material) {
      this.labelMesh.material.map = textSpriteTexture(this.label, labelStyle);
    }
  }


  onHoverStart(info) {
    info.material.color.set('#808080');
  }


  onHoverEnd(info) {
    info.material.color.set('#fff');
  }


  get label() {
    return this.panoCtlTo.linkLabel;
  }

}